import React, { useState } from "react";

// Кнопка копіювання тексту в буфер обміну з тимчасовим підтвердженням.
// getText дозволяє отримати текст асинхронно (напр. завантажити Markdown).
const CopyButton = ({ text, getText, label = "Скопіювати", className = "" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      const value = getText ? await getText() : text;
      if (value === false || value === undefined || value === null) return;
      if (typeof value === "string") {
        await navigator.clipboard.writeText(value);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Не вдалося скопіювати:", err);
    }
  };

  return (
    <button
      type="button"
      className={`copy-button ${className}`}
      onClick={handleCopy}
      disabled={copied}
    >
      {copied ? "Скопійовано!" : label}
    </button>
  );
};

export default CopyButton;
